/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';
import {HeaderTypography} from '@ion/dls/src/typography/HeaderTypography';

interface IonTagDetailsHeaderProps {
  ionTagName: string;
}

const useStyles = makeStyles((theme: DLSTheme) => {
  return {
    container : {
    },
    tagName : {
      fontFamily    : 'Roboto',
      fontWeight    : '600 !important',
      fontSize      : '16px !important',
      lineHeight    : '17px',
      textTransform : 'uppercase',
      color         : dlsColor('grey2'),
      padding       : '15px'
    }
  };
});

const IonTagDetailsHeader = ({ionTagName}: IonTagDetailsHeaderProps) => {
  const classes              = useStyles();

  return (
    <div className={classes.container}>
      <HeaderTypography className={classes.tagName} variant={'h3'}>
        {ionTagName}
      </HeaderTypography>
    </div>
  );
};
export default memo(IonTagDetailsHeader);
